export default __webpack_public_path__ + "static/media/revenueIcon.97f1d9b6.svg";